module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('h3', {
    staticClass: "h4 text-center"
  }, [(!_vm.isConfirm) ? _c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[95][1]"
    }
  })], 1) : _c('b', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[95][14]"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid page-head-wrap"
  }, [_c('div', {
    staticClass: "container page-head"
  }, [_c('p', {
    staticClass: " questionnaire-subhead mb-0"
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[95][2]"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 offset-lg-2 col-lg-8"
  }, [_c('page-form', {
    attrs: {
      "isConfirm": _vm.isConfirm
    },
    on: {
      "tryForm": _vm.tryForm,
      "toggleConfirm": _vm.toggleConfirm,
      "sendForm": _vm.sendForm
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-714f1838!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/subPages/Order/DemoQuestionnaireOrderer.vue
// module id = 714
// module chunks = 0